<template>
  <div v-if="response.length">
    <b-card>
      <b-form-row>
        <b-col cols="12">
          <b-table striped hover :items="items">
            <template v-slot:cell(label)="data">
              <b-link v-bind:href="'#/quotes/' + response[data.index].id">{{data.value}}</b-link>
            </template>
          </b-table>
        </b-col>
      </b-form-row>
      <b-form-row v-if="hasMore">
        <b-col cols="12">
          <b-button block variant="primary" v-on:click="$emit('loadMore')">Load More</b-button>
        </b-col>
      </b-form-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "quotes-results",
  props: ["response", "hasMore"],
  computed: {
    fields: function() {
      return [{ key: "label", label: "Label" }, "opportunities"];
    },
    items: function() {
      return this.response?.map(quote_summary => ({
        label: quote_summary.label,
        opportunities: quote_summary.opportunities
          .map(opportunity => opportunity.label)
          .join(", ")
      }));
    }
  }
};
</script>